import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3830eac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "panel-container show",
  id: "panel-body"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "送信先", -1))
const _hoisted_5 = { class: "col-md-10 contCnt" }
const _hoisted_6 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "本文", -1))
const _hoisted_9 = { class: "col-md-10 contCnt" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(190, 45, 45)"} }, [
  /*#__PURE__*/_createElementVNode("i", {
    "data-v-f21ed446": "",
    class: "fal fa-info-circle"
  }),
  /*#__PURE__*/_createTextVNode("送信者情報は自動的に追加されます ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mo_modal_l = _resolveComponent("Mo_modal_l")!

  return (_openBlock(), _createBlock(_component_Mo_modal_l, { ref: "modal_insurance" }, {
    title: _withCtx(() => [
      _createTextVNode("保険申請依頼")
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_vSelect, {
              multiple: "",
              options: _ctx.delegate4list.items4staffInsurance,
              modelValue: _ctx.selectedIds,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedIds) = $event)),
              label: "c_staff_name",
              reduce: (label) => label.c_staff_id
            }, null, 8, ["options", "modelValue", "reduce"]),
            (_ctx.errors?.path === 'sendTo')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.errors.message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("textarea", {
              name: "",
              id: "mailBody",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mailbody) = $event))
            }, null, 512), [
              [_vModelText, _ctx.mailbody]
            ]),
            _hoisted_10
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-info waves-effect waves-themed",
        "data-dismiss": "modal",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendMail()))
      }, " 送信 "),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary waves-effect waves-themed",
        "data-dismiss": "modal",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeModal()))
      }, " 閉じる ")
    ]),
    _: 1
  }, 512))
}